














































import { Component, Vue } from "vue-property-decorator";
import { ReportsModule } from "@/store/reports.module";
import { ReportAction } from "~/services/report";
import { ChangePlanModule } from "@/store/change-plan.module";
import { BaseModule } from "@/store/base.module";
import moment from "moment";

@Component({})
export default class SingleReportUnwrapped1 extends Vue {
  formRef = "form";
  docGuid: string;

  async generate(action: ReportAction) {
    if (this.docGuid) this.getFileByGuid(action);
    else {
      await ReportsModule.generateReport({
        action: action,
        path: "application-1.prpt",
        type: "pdf",
        filename: this.$t("reportsInfo.application-1.title") as string,
        query: {
          iContractId: this.$route.params.id,
        },
      });
    }
  }
  async getFileByGuid(action: ReportAction) {
    try {
      BaseModule.setLoadingStatus(true);
      const r = await ReportsModule.getDoc(this.docGuid);
      const byteOffset = 0;
      const b = new Blob(
        [new Uint8Array((r as any).result.data, byteOffset, length)],
        { type: "application/pdf" },
      );
      const fileURL = URL.createObjectURL(b);
      if (action == "open") window.open(fileURL);
      else {
        const link = document.createElement("a");
        link.href = fileURL;
        link.setAttribute(
          "download",
          this.$t("reportsInfo.application-1.title") as string,
        ); //or any other extension
        document.body.appendChild(link);
        link.click();
      }
    } finally {
      BaseModule.setLoadingStatus(false);
    }
  }
  async mounted() {
    const doc = await ChangePlanModule.getCurrentChangePlanDoc(
      parseInt(this.$route.params.id),
    );
    if (doc) this.docGuid = doc.qr_guid;
  }
}
